import React from 'react';
import appStyles from '../App.module.css';
import styles from './Pages.module.css';
import Wall from '../components/Wall';
import Tile from '../components/Tile';
import NewsletterForm from '../components/NewsletterForm';

/**
 * /education — the community tech education mission, standalone.
 * Programs listed here are honestly labeled as "taking shape" — nothing is
 * promised that doesn't exist yet; the page's job is to attract the people
 * (and partners) who'll help build them.
 */

const Education: React.FC = () => (
  <Wall>
    {/* Page hero — span 4, surface */}
    <Tile span={4} tone="surface">
      <div className={styles.kicker}>✦ The mission</div>
      <h1 className={styles.slab}>Community<br />Tech Education</h1>
      <p className={styles.lead}>
        <b>Real tools in neighborhood hands.</b>{' '}
        Dallas tech gravity pulls north. The talent is already here — what&rsquo;s
        missing is the on-ramp. We&rsquo;re building it in Oak&nbsp;Cliff, for
        Oak&nbsp;Cliff.
      </p>
    </Tile>

    {/* 01 / Who It's For — span 2, brick */}
    <Tile span={2} tone="brick" label="01 / Who It's For" glyph="✦">
      <p className={styles.creamCopy}>
        <b>Kids</b> curious about how things get made. <b>Career-switchers</b>{' '}
        plotting a way into tech. <b>Neighbors</b> who just want to understand
        the tools shaping their world.
      </p>
    </Tile>

    {/* 02 / What's Taking Shape — span 3 */}
    <Tile span={3} label="02 / What's Taking Shape" glyph="▸">
      <div className={appStyles.list}>
        <div className={appStyles.listItem}>
          <b>Workshops</b>
          <span>Hands-on sessions — intro to code, design basics, hardware tinkering. Bring nothing but curiosity.</span>
        </div>
        <div className={appStyles.listItem}>
          <b>Skill shares</b>
          <span>Neighbors teaching neighbors what they already know. Everyone here is an expert in something.</span>
        </div>
        <div className={appStyles.listItem}>
          <b>Mentorship</b>
          <span>Real pairings between working builders and people finding their way in.</span>
        </div>
      </div>
    </Tile>

    {/* 03 / Where It Stands — span 3, olive (honesty tile) */}
    <Tile span={3} tone="olive" label="03 / Where It Stands" glyph="✦">
      <p className={styles.creamCopy}>
        <b>Early — and we&rsquo;d rather say so.</b> These programs are being
        shaped right now by the people who show up. Getting in early means
        getting a say in what gets built first.
      </p>
    </Tile>

    {/* 04 / Help Build It — span 3 */}
    <Tile span={3} label="04 / Help Build It" glyph="▸">
      <p className={appStyles.copy}>
        <b>Can you teach, host, or lend gear?</b>{' '}
        A skill worth sharing, a room with tables, laptops gathering dust — it
        all moves this forward. Email{' '}
        <a className={styles.link} href="mailto:hello@oakcliff.tech">hello@oakcliff.tech</a>{' '}
        and tell us what you&rsquo;ve got.
      </p>
      <div className={styles.linkRow}>
        <a className={styles.link} href="/">
          ◂ Back to oakcliff.tech
        </a>
      </div>
    </Tile>

    {/* 05 / Get Involved — span 3, ochre */}
    <Tile span={3} tone="ochre" label="05 / Get Involved" glyph="◆">
      <NewsletterForm />
    </Tile>
  </Wall>
);

export default Education;
